export const setOptions = data => {
    return {
        type: "SET_OPTIONS",
        data,
    }
}
